<template>
  <main class="legal" v-html="renderedHtml"></main>
  <AppFooter />
</template>

<script>
import { marked } from "marked";
import AppFooter from "../components/AppFooter.vue";
import legalFr from "../i18n/legal/legal.fr.md";
import legalEn from "../i18n/legal/legal.en.md";
import legalDe from "../i18n/legal/legal.de.md";

const SOURCES = { fr: legalFr, en: legalEn, de: legalDe };

export default {
  name: "LegalPage",
  components: {
    AppFooter,
  },
  computed: {
    renderedHtml() {
      const locale = this.$i18n.locale;
      const md = SOURCES[locale] || SOURCES.en;
      return marked.parse(md);
    },
  },
};
</script>

<!-- Layout + typography styles live in src/styles/legal-pages.css (imported globally
     in main.js) because the content is rendered via v-html (marked) and Vue scoped
     CSS does not reach those nodes. -->
